export default __webpack_public_path__ + "static/use@992-7cb15fca3436b2adb12d2e807c75d9b2.jpg";